import { gql } from "@apollo/client";
import moment from 'moment';

export const UPDATE_EVALUACION_CONDICION = gql`
mutation updateEvaluacionCondicion($input: UpdateEvaluacionCondicionInput!) {
    updateEvaluacionCondicion(input: $input){
        idEvaluacion
    }
}`;

export const adaptEvaluacionCondicionInput = (idEvaluacion, condicionContratoData) => ({
  idEvaluacion,
  fechaDesde: !condicionContratoData?.fechaDesde ? null : moment(condicionContratoData?.fechaDesde).set({ hour: 0, minute: 0, second: 0 }).format('yyyy-MM-DD HH:mm:ss'),
  fechaHasta: !condicionContratoData?.fechaHasta ? null : moment(condicionContratoData?.fechaHasta).set({ hour: 0, minute: 0, second: 0 }).format('yyyy-MM-DD HH:mm:ss'),
  diasCorridosContrato: condicionContratoData?.diasContrato,
  diasTratamiento: condicionContratoData?.diasTratamiento,
  condicionPago: condicionContratoData?.condicionCliente,
  precioDiario: condicionContratoData?.precioDiario,
  estadoPrecio: condicionContratoData?.estadoPrecio,
  cotizado: condicionContratoData?.cotizado,
  ajustePrestacion: condicionContratoData?.ajustePrestacion
});